import {
  UPDATE_GAMESTATE,
  SET_STEP,
  SET_ROUND,
  UPDATE_PROJECT,
  UPDATE_MY_STATE,
  UPDATE_INPUT_STATES,
  UPDATE_HANDLING_ROUND_STATE_CHANGE,
  FORCE_LANGUAGE
} from '../actions/types';


const { getGameStateSum } = require('../helpers/gameStateHelpers');

let gameStateSum = {};
let Rounds = [];
let activatedStepUpdated = false;

/**
 *
 * @type {{gameStateSum: Object, Rounds: Array}}
 */
const initialState = {
  prevRoundTaxPoints: 0,
  gameStateSum,
  Rounds,
  currentRound: 1,
  roundData: {
    roundNumber: 0,
  },
  loaded: false,
  currentStep: 0,
  allowNewGame: true,
  allowFeedbackActivate: false,
  simGameEntry: '/',
  nextStepState: 'SIMULATION_TAX',
  stepPopup: {},
  difficulty: 'PRO',
  language: 'NL',
  theme: 'red',
  showScores: true,
  budgetLeft: 0,
  exittedEarly: false,
  handlingRoundStateChange: false,
};

/**
 * gameState reducer method
 * @param {Object} state
 * @param {Object} action
 * @return {{gameStateSum: Object, Rounds: Array}}
 */
const gameState = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case UPDATE_PROJECT:
      if (state.handlingRoundStateChange) {
        state.handlingRoundStateChange = false;
      }
      if (payload.gameState) {
        gameStateSum = payload.gameState.gameStateSum;
        state.showScores = payload.project.showScores;
        Rounds = payload.gameState.Rounds;
        state.DefaultDifficultyId = payload.project.DefaultDifficultyId;
        if (!state.roundOverwritten) {
          state.currentRound = Rounds.length - 1;
        }
        state.exittedEarly = payload.project.exittedEarly;
        state.theme = payload.group.GroupTheme.color;
        state.difficulty = state.DefaultDifficultyId === 2 ? 'BASIC' : 'PRO';
        if (payload.schoolClass && typeof payload.schoolClass.Language === 'object') {
          state.language = payload.schoolClass.Language.code.toUpperCase();
        }
      }
      state.loaded = true;
      break;
    case UPDATE_GAMESTATE:
      gameStateSum = payload.gameStateSum;
      Rounds = payload.Rounds;
      if (!state.roundOverwritten) {
        state.currentRound = Rounds.length - 1;
      }
      break;
    case UPDATE_MY_STATE:
      activatedStepUpdated = ((state.activatedStep !== payload.activatedStep) && payload.activatedStep);
      if (activatedStepUpdated) {
        state.activatedStep = payload.activatedStep;
      }
      break;
    case UPDATE_INPUT_STATES:
      if (payload.updateOwnGroup) {
        activatedStepUpdated = ((state.activatedStep !== (payload.myState || {}).activatedStep) && (payload.myState || {}).activatedStep);
        if (activatedStepUpdated) {
          state.activatedStep = payload.myState.activatedStep;
        }
      }
      break;
    case UPDATE_HANDLING_ROUND_STATE_CHANGE:
      state.handlingRoundStateChange = true;
      break;
    case SET_STEP:
      state.currentStep = payload;
      break;
    case SET_ROUND:
      state.history = payload < state.Rounds.length -1;
      state.currentRound = payload;
      state.roundOverwritten = (payload !== state.Rounds.length - 1);
      break;
    case FORCE_LANGUAGE:
      state.language = payload;
      break;
    default:
      return state;
  }
  if(!Rounds.length) return {
    ...initialState,
  };
  state.gameStateSum = gameStateSum;
  state.Rounds = Rounds || [];
  state.roundData = ({ ...state.Rounds[state.currentRound] }); // We want to lose the reference here, so we make a clone instead of using the actual object.
  state.roundData.GameStates = state.roundData.GameStates.filter(gs => !['TEACHER_INTERVENTION', 'BONUS_ASSIGNMENT'].includes(gs.type));
  state.allowNewGame = state.roundData.state === 'END' || state.roundData.state === 'PLAYING_GAME';
  state.prevRound = Rounds.find(r => r.roundNumber === (state.currentRound-1));
  state.prevRoundSum = getGameStateSum(state.prevRound.GameStates);
  state.sumUpToPrevRound = getGameStateSum(
    Rounds
      .slice(0, state.currentRound)
      .reduce( (acc, r) => acc.concat(r.GameStates), [])
  );
  state.sumUpToTax1 = getGameStateSum([state.sumUpToPrevRound, (state.roundData.GameStates[0]) || {}]);
  state.oneTimeEffect = state.prevRoundSum.OneTimeEffect;
  state.totalEconomy = state.oneTimeEffect.economie + state.roundData.earnedGlobas;
  state.prevRoundTaxPoints = state.prevRoundSum.AB_points + state.prevRoundSum.BB_points + state.prevRoundSum.V_points + state.prevRoundSum.VV_points + state.prevRoundSum.C_points;
  state.totalEconomyPoints = state.prevRoundSum.points + state.roundData.earnedPoints - state.prevRoundTaxPoints;
  state.currentlyPlaying = (state.roundData.GameId && state.roundData.state === 'PLAYING_GAME')
    ? state.roundData.GameId
    : null;
  state.simGameActive = state.roundData.state.includes('SIMULATION_');
  state.totalGameStateSum = getGameStateSum(
    Rounds
      .slice(0, state.currentRound+1)
      .reduce( (acc, r) => acc.concat(r.GameStates), [])
  );
  const roundDataStates = state.roundData.GameStates.filter(gs => gs.type !== 'TEACHER_INTERVENTION' && gs.type !== 'BONUS_ASSIGNMENT');
  state.roundData.lastGameState = roundDataStates[roundDataStates.length - (state.history && state.currentStep === 3 ? 2 : 1)] || { OneTimeEffect: {} };
  state.currentDebitCredit = state.roundData.lastGameState.OneTimeEffect.debitCredit || [];
  state.endOfGame = (state.Rounds[4] && state.Rounds[4].state === 'END') ||  state.Rounds.length > 5 || state.exittedEarly;
  state.hideScores = !state.showScores;
  state.allowFeedbackActivate = (state.roundData.state === 'SCORE_SUBMITTED' || (state.endOfGame && state.Rounds.length <= 5));
  if (state.exittedEarly && state.roundData.state === 'SIMULATION_START') {
    state.allowFeedbackActivate = false;
  }
  state.budgetLeft = 0;
  for(let i = 0; i < state.Rounds.length - 1; i += 1) {
    const sum = getGameStateSum(state.Rounds[i].GameStates);
    state.budgetLeft += sum.globas;
  }

  let tmpState = state.roundData.state;
  // Set current step
  if (!state.currentStep || activatedStepUpdated) {
    switch (state.roundData.state) {
      case 'SIMULATION_START':
        state.currentStep = 1;
        break;
      case 'SIMULATION_TAX':
        state.currentStep = state.activatedStep === 2 ? 2 : 1;
        break;
      case 'SIMULATION_TAX_2':
        tmpState = 'SIMULATION_TAX';
        state.currentStep = state.activatedStep === 2 ? 2 : 1;
        break;
      case 'SIMULATION_SPENDING':
        state.currentStep = state.activatedStep === 3 ? 3 : 2;
        break;
      default:
    }
  }

  // Set entry point for simgame
  switch(state.currentStep) {
    case 1:
      state.simGameEntry = '/';
      state.nextStepState = 'SIMULATION_TAX';
      if (state.currentRound === 5) {
        state.stepPopup = state.difficulty === 'PRO' ? 'mhgvthoestaatjelandervoor_1' : 'mlgvthoestaatjelandervoor_1';
      } else {
        state.stepPopup = state.difficulty === 'PRO' ? 'mhgvthoestaatjelandervoor' : 'mlgvthoestaatjelandervoor';
      }
      break;
    case 2:
      state.simGameEntry = '/taxes';
      state.nextStepState = 'SIMULATION_SPENDING';
      state.stepPopup = state.difficulty === 'PRO' ? 'mhgvtbelastingheffen' : 'mlgvtbelastingheffen';
      break;
    case 3:
      state.simGameEntry = '/';
      state.nextStepState = 'END';
      state.stepPopup = state.difficulty === 'PRO' ? 'mhgvtbudgetverdelen' : 'mlgvtoverzicht_verdelen';
      break;
    default:
  }
  state.lastGameState = {};
  state.nextStepUnlocked = tmpState === state.nextStepState;

  for(let c = Rounds.length-1; c >= 0; c -= 1) {
    const g = Rounds[c].GameStates;
    if(g.length) {
      const gStates = g.filter(gs => gs.type !== 'BONUS_ASSIGNMENT' && gs.type !== 'TEACHER_INTERVENTION');
      state.lastGameState = gStates[gStates.length-1];
      break;
    }
  }
  return {...state};
};

export default gameState;



// WEBPACK FOOTER //
// ./src/reducers/gameState.js